// extracted by mini-css-extract-plugin
export default {"about":"about_about__3QuAN","grid":"about_grid__dAjKe","logoDiv":"about_logoDiv__RmJKn","logo":"about_logo__gXdqf"};